export default __webpack_public_path__ + "static/media/5Y.8dfd1d59.png";